/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AddCategory from "../../Modals/addCategory";
import IosSwitchMain from "../../components/iosSwitchMain";
import { Categories } from "../../types/General";
import { showError, showToast } from "../../constants/toasts";
import {
  useChangeCategoryStatusMutation,
  useLazyDeleteCategoryQuery,
} from "../../service/category";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useSetCategoryOrderMutation } from "../../service/offer";
import { formatDubaiDateTime } from "../../utils/dateTime";

type RowData = {
  id: string;
  criteriaName: string;
  factors: string;
};
interface DraggableListProps {
  data: RowData[];
}

interface DraggableRowProps {
  row: RowData;
}

function DraggableRow({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) {
  const { setNodeRef, attributes, listeners, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      hover
    >
      {children}
    </TableRow>
  );
}

const CategoryList = ({
  activeTab,
  data,
  page,
  selectedCategory,
  setSelectedCategory,
  selectedId,
  setSelectedId,
  getCategoryApi,
}: {
  activeTab: number;
  data: Categories[];
  page: number;
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
  selectedCategory?: Categories | null;
  setSelectedCategory: Dispatch<SetStateAction<Categories | null>>;
  getCategoryApi: () => void;
}) => {
  const [deleteCategory] = useLazyDeleteCategoryQuery();
  const [categoryStatus] = useChangeCategoryStatusMutation();
  const [setOrder] = useSetCategoryOrderMutation();

  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleCloseModal = () => setOpen(false);

  const [rows, setRows] = useState<any[]>(data);

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = async (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = rows.findIndex((r: any) => r.id === active.id);
    const newIndex = rows.findIndex((r: any) => r.id === over.id);
    const updated = [...rows];
    const [moved] = updated.splice(oldIndex, 1);
    updated.splice(newIndex, 0, moved);
    setRows(updated);

    const payload = updated?.map((item, index) => ({
      id: item?.id,
      order: index,
    }));

    try {
      let response;
      response = await setOrder(payload).unwrap();

      if (response?.status === 200) {
        showToast(response?.message || "");
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const deleteCategoryApi = async () => {
    try {
      const response = await deleteCategory({ id: selectedId }).unwrap();
      if (response.status === 200) {
        getCategoryApi();
        showToast(response?.message || "");
      } else {
        showError(response?.message || "-");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const changeCategoryStatusApi = async (id: string) => {
    const currentRow = rows?.find((r) => r?.id === id);
    const isCurrentlyActive = currentRow?.isActive;

    // Check how many active categories exist
    const activeCount = rows?.filter((r) => r?.isActive)?.length;

    // Prevent disabling the last active one
    if (isCurrentlyActive && activeCount === 1) {
      showError("At least one category must remain active.");
      return;
    }

    try {
      const response = await categoryStatus({ id }).unwrap();
      if (response?.status === 200) {
        getCategoryApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (data?.length) {
      setRows(data);
    } else {
      setRows([]);
    }
  }, [data]);

  return (
    <>
      {/* <div className="sorting_table">
        <TableComponent columns={filteredColumns} rows={data} />
      </div> */}
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={rows.map((r: any) => r.id)}
          strategy={verticalListSortingStrategy}
        >
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr.no</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Category Name</TableCell>
                  <TableCell>Created Date</TableCell>
                  <TableCell>Show</TableCell>
                  <TableCell>Action</TableCell>
                  <TableCell>Drag & Drop</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.length ? (
                  rows?.map((row: any, i: any) => (
                    <TableRow key={i}>
                      <TableCell>{(page - 1) * 10 + i + 1}</TableCell>
                      <TableCell>
                        <div className="user_block click_action">
                          <figure>
                            <img
                              src={
                                row?.imageUrl
                                  ? row?.imageUrl
                                  : "/static/images/user_placeholder.png"
                              }
                              alt="Category"
                            // style={{
                            //   width: "40px",
                            //   height: "40px",
                            //   objectFit: "cover",
                            //   borderRadius: "8px",
                            // }}
                            />
                          </figure>
                        </div>
                      </TableCell>
                      <TableCell>
                        <p>{row?.name}</p>
                      </TableCell>
                      <TableCell>
                        <p>
                          {row?.date ? formatDubaiDateTime(row?.date) : "-"}
                        </p>
                      </TableCell>
                      <TableCell>
                        {" "}
                        <IosSwitchMain
                          checked={row?.isActive}
                          disabled={row?.isActive && rows?.filter((r) => r?.isActive)?.length === 1}
                          onChange={() => changeCategoryStatusApi(row?.id)}
                        />
                      </TableCell>
                      <TableCell>
                        <div className="table_actions v2">
                          <Box>
                            <IconButton
                              onClick={() => {
                                setSelectedId(row?.id);
                                setSelectedCategory(row);
                                setOpen(true);
                              }}
                            >
                              <img
                                src="/static/images/edit_icon.svg"
                                alt="Edit"
                              />
                            </IconButton>
                          </Box>
                          <Box>
                            <IconButton
                              onClick={() => {
                                setSelectedId(row?.id);
                                setOpenDelete(true);
                              }}
                            >
                              <img
                                src="/static/images/trash2_icon.svg"
                                alt="Delete"
                              />
                            </IconButton>
                          </Box>
                        </div>
                      </TableCell>
                      <TableCell>
                        {/* <div className="table_actions v2">
                      <Box>
                        <IconButton className="drag_btn">
                          <MenuIcon />
                        </IconButton>
                      </Box>
                    </div> */}
                        <DraggableRow key={row.id} id={row.id}>
                          <IconButton>
                            <MenuIcon sx={{ color: "#ffffff" }} />
                          </IconButton>
                        </DraggableRow>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </SortableContext>
      </DndContext>
      <AddCategory
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        selectedCategory={selectedCategory}
        selectedId={selectedId}
        getCategoryApi={getCategoryApi}
      />

      <ConfirmationModal
        text={"Are you sure to delete this Category?"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={deleteCategoryApi}
      />
    </>
  );
};

export default CategoryList;
